export default __webpack_public_path__ + "static/media/lesson4.73c12723.svg";